import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-portfolio-card',
  templateUrl: './portfolio-card.component.html',
  imports: [],
  styleUrls: ['./portfolio-card.component.scss']
})
export class PortfolioCardComponent {

  @Input() project:any; //= new ProjectBriefResponse();

}
